import s from "./contacts.module.css";


const ContactItem = (props) => {
    return (
        <div className={s.infoItem}>
            <img src={props.img} alt=""/>
            <div>
                <h5>{props.title}</h5>
                <p>{props.info}
                </p>
            </div>
        </div>
    )
}

export default ContactItem;